import { ReactNode } from "react"
import {
  Block,
  FlexGrid,
  FlexGridItem,
  HeadingSmall,
  ParagraphSmall,
  Skeleton,
  useStyletron,
} from "@mezo-org/mezo-clay"

type HomepageMainSectionAssetsItemProps = {
  header: ReactNode
  title?: string
  value: ReactNode
  label: ReactNode
  buttons: ReactNode[]
  isLoading?: boolean
}

export default function HomepageMainSectionAssetsItem({
  header,
  title,
  value,
  label,
  buttons,
  isLoading,
}: HomepageMainSectionAssetsItemProps) {
  const [, theme] = useStyletron()

  return (
    <Block
      backgroundColor="white"
      height="222px"
      padding={theme.sizing.scale600}
      overrides={{
        Block: {
          style: () => ({
            borderRadius: theme.borders.radius400,
            border: "1px solid #E8E8E8",
          }),
        },
      }}
    >
      <Block
        marginBottom={theme.sizing.scale900}
        height={theme.sizing.scale800}
      >
        {header}
      </Block>
      <Block height={theme.sizing.scale700}>
        {title && (
          <ParagraphSmall color={theme.colors.contentSecondary}>
            {title}
          </ParagraphSmall>
        )}
      </Block>
      {isLoading ? (
        <Skeleton width="160px" height="32px" animation />
      ) : (
        <HeadingSmall>{value}</HeadingSmall>
      )}
      <Block
        marginBottom={theme.sizing.scale700}
        height={theme.sizing.scale800}
      >
        {label}
      </Block>
      <FlexGrid
        flexGridColumnCount={buttons.length}
        flexGridColumnGap={theme.sizing.scale300}
        height="36px"
      >
        {buttons.map((button, index) => (
          <FlexGridItem
            // eslint-disable-next-line react/no-array-index-key
            key={`button-${index}`}
            overrides={{
              Block: {
                style: () => ({ width: "auto", flexGrow: 0 }),
              },
            }}
          >
            {button}
          </FlexGridItem>
        ))}
      </FlexGrid>
    </Block>
  )
}
